module.exports = __webpack_public_path__ + "img/team_1.101ec1dc.png";